import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  deviceIds:any;
  fetchCurrentPageData:any = {};
  private apiUrl = environment.apiUrl;
  private otaUrl = environment.otaUrl;
  checkboxData = new BehaviorSubject<number>(1);

  constructor(private http: HttpClient) {}

  getAllDevices(
    // page: number = 0,
    // size: number = 10,
    // filters: { field: 'deviceType'; operator: 'Like'; value: '' }[] = [],
    // sorts: { field: string; direction: string }[] = []
    body: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });

    // const body = {
    //   "page": 0,
    //   "size": 10,
    //   "filters": [
    //     {
    //       "field": "",
    //       "operator": "",
    //       "value": ""
    //     }
    //   ],
    //   "sorts": [
    //     {
    //       "field": "deviceType",
    //       "direction": "asc"
    //     }
    //   ]
    // }

    return this.http.post(`${this.apiUrl}/devices/v1/device/search`, body, {
      headers,
    });
  }

  getDeviceDetailsById(id: any) {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    let url = `${this.apiUrl}/devices/v1/device/${id}`;
    return this.http.get(url, { headers });
  }

  getDeviceAuditHistory(body: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    let url = `${this.apiUrl}/installation/v1/history/device/audit`;
    return this.http.post(url, body, { headers });
  }
  getOtaAuditHistory(body: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    let url = `${this.apiUrl}/audit/v1/search/ota-audit-history`;
    return this.http.post(url, body, { headers });
  }
  getDeviceConfigAudits(body: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    let url = `${this.otaUrl}/device-config-audits/search`;
    return this.http.post(url, body, { headers });
  }
  getDeviceDetailsSearch(body: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    let url = `${this.apiUrl}/device-detail/search`;
    return this.http.post(url, body, { headers });
  }
  getDeviceAuditEngineering(body: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    let url = `${this.apiUrl}/installation/v1/history/device/audit/engineering`;
    return this.http.post(url, body, { headers });
  }

  public upload(formData: any, customerId: string, customerGroupId: string) {
    const url = `${this.apiUrl}/devices/bulkUploadExcel?customerId=${customerId}&customerGroupId=${customerGroupId}`;
    return this.http.post<any>(url, formData, {
      reportProgress: true,
    });
  }
  public validateExcel(formData: any, customerId: string, otaGroupId: string) {
    const url = `${this.apiUrl}/devices/v1/device/ValidateBulkExcel?customerId=${customerId}&otaGroupId=${otaGroupId}`;
    return this.http.post<any>(url, formData, {
      reportProgress: true,
    });
  }

  public getCustomerList(payload: any) {
    return this.http.post(
      this.apiUrl + '/customers/v1/customer/search',
      payload
    );
  }
  public getOtagroupIdList(customerId: any) {
    return this.http.get(
      `${this.apiUrl}/ota/v1/group/customer/${customerId}?page=0&size=200`
    );
  }

  getAllRecords(rowCount: any,payload:any): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    return this.http.post(`${this.apiUrl}/devices/v2/device/search`, payload, {
      headers,
    });
  }

  updatePeripheralId(deviceId: string, peripheralId: string): Observable<any> {

    return this.http.put(`${this.apiUrl}/peripherals/v1/peripherals/${deviceId}/peripheralId`,
      { peripheralId }
    );
  }
  getExportComparisonDataXL(deviceId: string): Observable<Blob> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    const url = `${this.apiUrl}/reconciliation/export/excel`;
    const body = [deviceId];
    return this.http.post(url, body, { headers, responseType: 'blob' });
  }


  /* Start OTA API's  */
  uploadOta(payload:any){
    const otaUrl = `${this.otaUrl}/device-config-updates/create`;
    return this.http.post(otaUrl, payload);
    // return this.http.post(`https://device-interaction-webapp.azurewebsites.net/api/device-config-updates/create`, payload)
  }

  getDeviceConfigList(body: any): Observable<any> {
    //const apiUrl = `${this.apiUrl}/device-config-updates/search`;
    const otaUrl = `${this.otaUrl}/device-config-updates/search`;
    return this.http.post(otaUrl, body);
  }

  getDeviceConfigHistory(body: any): Observable<any> {
    //const apiUrl = `${this.apiUrl}/device-config-updates/search`;
    const otaUrl = `${this.otaUrl}/device-config-audits/search`;
    return this.http.post(otaUrl, body);
  }
  updateDeviceList(payload:any){
    return this.http.post(`${this.apiUrl}/devices/v1/device/bulkUpdateCustomerGroup`,payload);
  }

  getConfigHistoryList(cpId: number, gpId: number): Observable<any> {
    //const apiUrl = `${this.apiUrl}/device-config-updates/search`;
    //const otaUrl = `${this.otaUrl}/device-config-updates/customer/${cpId}/group/${gpId}?page=0&size=10&sort=dateTime&sort=desc`;
    const otaUrl = `${this.otaUrl}/device-config-updates/customer/${cpId}/group/${gpId}?page=0&size=100`

    return this.http.get(otaUrl);
  }
  promoteConfigList(configId:any,payload:any)
  {
    const otaUrl = `${this.otaUrl}/device-config-updates/promote-to-multiple-groups?sourceConfigId=${configId}`;
    return this.http.post(otaUrl,payload)
  }
  getDeviceHealthDetail(gatewayId: string): Observable<any> {
    const url = `${this.apiUrl}/device-detail/${gatewayId}`;
    return this.http.get(url);
  }

  searchDeviceHealth(gatewayId: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    const url = `${this.apiUrl}/device-detail/health/search/${encodeURIComponent(gatewayId)}`;
    return this.http.post(url, body, { headers });
  }

  getSimComparisonOverview(gatewayId: string): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    const url = `${this.apiUrl}/sim-management/v1/sim-comparison/${encodeURIComponent(gatewayId)}`;
    return this.http.get(url, { headers });
  }

  getActiveSimProfile(gatewayId: string): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    const url = `${this.apiUrl}/sim-management/v1/active-profile/${encodeURIComponent(gatewayId)}`;
    return this.http.get(url, { headers });
  }

  getMongoConfig(gatewayIds: string[]): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
      'Content-Type': 'application/json',
    });
    const url = `${this.apiUrl}/mongo-config`;
    return this.http.post(url, gatewayIds, { headers });
  }

  getTealEsimDataUsage(eid: string, startDate?: string, endDate?: string): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    let params = new HttpParams();
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    const url = `${this.apiUrl}/v1/teal/esim/${encodeURIComponent(eid)}/data-usage`;
    return this.http.get(url, { headers, params });
  }

   /* End OTA API's  */
}
